// extracted by mini-css-extract-plugin
export default {"root":"account-profile-header_root__7JARq","title":"account-profile-header_title__y+Z6N"};